import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { RouterProvider } from "react-router-dom";
import styled from "styled-components";
import { createBrowserRouter } from "react-router-dom";
import RouterList from "./layout/configRoutes";
import { Provider } from "jotai";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const router = createBrowserRouter([...RouterList]);

  return (
    <ContainerMain>
      <Provider>
        <RouterProvider router={router} />
      </Provider>
    </ContainerMain>
  );
}

const ContainerMain = styled.div`
  position: relative;

  .main-layout {
    width: 256px;
    position: fixed;
    top: 0;
    overflow: hidden;
    background-image: linear-gradient(
      270deg,
      rgba(51, 148, 225, 0.18),
      transparent
    );
    background-color: #584475;
  }

  @media (max-width: 992px) {
    .main-layout {
      width: 200px;
    }
    .ant-menu-light {
      width: 200px !important;
    }
  }

  @media only screen and (max-width: 767px) {
    .main-layout {
      position: fixed;
      top: 0;
      overflow: hidden;
      background-image: linear-gradient(
        270deg,
        rgba(51, 148, 225, 0.18),
        transparent
      );
      background-color: #584475;
      width: 100vw;
      z-index: 9;
    }

    .ant-menu-light {
      width: auto !important;
    }
  }
`;
